jQuery(function () {
  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  whenGsapReady(() => {
    whenScrollReady(() => {
      initResearchPublicationsArchive();
    });
  });

  function initResearchPublicationsArchive() {
    const root = document.querySelector(".js-research-publications-archive");
    if (!root) return;
    if (root.dataset.rpaBound === "1") return;
    root.dataset.rpaBound = "1";

    const list = root.querySelector(".js-rpa-list");
    const moreBtn = root.querySelector(".js-rpa-more");
    const filters = root.querySelector(".rpa__filters");

    if (!list) return;

    let term = "all";
    let page = 1;
    let busy = false;

    const gsap = window.gsap;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap?.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap?.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    function setLoading(on) {
      list.classList.toggle("is-loading", on);
      list.style.opacity = on ? "0.55" : "1";
      list.style.pointerEvents = on ? "none" : "";
      if (moreBtn) moreBtn.disabled = on;
    }

    function animateIn(items) {
      if (!gsap || reduceMotion || !items.length) return;
      gsap.fromTo(
        items,
        { autoAlpha: 0, y: 10 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.4,
          ease: "power2.out",
          stagger: 0.04,
          clearProps: "transform",
        },
      );
    }

    // Initial reveal animation (same feel as Expert Voice archive)
    const initialItems = Array.from(root.querySelectorAll(".js-rpa-item"));
    if (gsap && initialItems.length) {
      if (!reduceMotion) {
        gsap.set(initialItems, { autoAlpha: 0, y: 16 });
        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          stagger: 0.07,
          clearProps: "transform",
        };
        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: root,
            start: "top 78%",
            once: true,
            invalidateOnRefresh: true,
          };
        }
        gsap.to(initialItems, vars);
      } else {
        gsap.set(initialItems, { autoAlpha: 1, y: 0, clearProps: "transform" });
      }
    }

    function fetchPage(nextPage, mode) {
      if (busy) return;
      busy = true;
      setLoading(true);

      const fd = new FormData();
      fd.append("action", root.dataset.rpaAction || "nl_research_publications_archive");
      fd.append("nonce", root.dataset.rpaNonce || "");
      fd.append("term", term);
      fd.append("page", String(nextPage));
      fd.append("per_page", root.dataset.rpaPpp || "6");

      fetch(root.dataset.rpaEndpoint || "/wp-admin/admin-ajax.php", {
        method: "POST",
        body: fd,
        credentials: "same-origin",
      })
        .then((r) => r.json())
        .then((json) => {
          if (!json || !json.success || typeof json.data?.html !== "string") {
            return;
          }

          // Build real nodes so we can animate what we actually insert.
          const tmp = document.createElement("div");
          tmp.innerHTML = json.data.html;
          const insertedItems = Array.from(tmp.querySelectorAll(".js-rpa-item"));
          const nodes = Array.from(tmp.childNodes);

          if (mode === "replace") {
            list.innerHTML = "";
            nodes.forEach((n) => list.appendChild(n));
            page = 1;
          } else {
            nodes.forEach((n) => list.appendChild(n));
            page = nextPage;
          }

          const newItems = insertedItems;

          const hasMore = !!json.data.has_more;
          if (moreBtn) {
            moreBtn.style.display = hasMore ? "" : "none";
          }

          animateIn(newItems);
        })
        .catch(() => {})
        .finally(() => {
          busy = false;
          setLoading(false);
        });
    }

    // Category filters (Expert Voice-style)
    if (filters) {
      filters.addEventListener("click", (e) => {
        const btn = e.target.closest(".eva__filter");
        if (!btn || !filters.contains(btn)) return;
        const next = btn.getAttribute("data-rpa-term") || "all";
        if (next === term) return;

        term = next;
        filters.querySelectorAll(".eva__filter").forEach((b) => {
          const on = b === btn;
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-selected", on ? "true" : "false");
        });

        // Smoothly reset UI between category changes.
        page = 1;
        if (moreBtn) moreBtn.style.display = "";
        fetchPage(1, "replace");
      });
    }

    // Show more
    if (moreBtn) {
      moreBtn.addEventListener("click", () => {
        fetchPage(page + 1, "append");
      });
    }
  }
});

